<template>
  <div>User administration will live here...</div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';

  @Component({
    components: {},
  })
  export default class Users extends Vue {
    private isDirty = false;

    async save() {
      this.isDirty = false;
    }
  }
</script>

<style scoped lang="scss"></style>
